<template>
    <v-layout justify-center>
   <v-flex xs12 sm8 md8 lg6 text-xs-center>
    <img :src="'img/' + this.profile.image" class="profile-image" alt="as">
    <p class="title">{{ this.profile.profile }}</p>

    <p class="body-1">
        {{ this.profile.description }}
    </p>

    <v-btn round color="#1b5e1f" class="white--text"  :href="'cards/' + this.profile.card">Lataa vinkit</v-btn>

    <p class="body-1 mt-3">
        Metsä on tuottoisa oikein hoidettuna. Tässä sinulle vinkit, kuinka saat metsäsi tuottamaan näköistäsi tuottoa!
        Voit tallentaa vinkit tietokoneellesi ja tulostaa ne. Ota vinkit käyttöön ja laita metsäsi tuottamaan!
    </p>
    

    <p class="body-2">
        Kerro ystävillesi, mitä sinun metsäsi tuottaa ja jaa tulos sosiaalisessa mediassa!
    </p>
    <v-btn round @click="shareOnFacebook">Jaa Facebookissa</v-btn>
    <p class="body-2">
    </p>
    <p class="body-1">
        Jos sinulla on kysyttävää tai palautetta Metsätuotto-palvelusta, voit lähettää sähköpostia osoitteeseen mobiilistimetsaan (a) gmail.com.
    </p>

    <v-btn class="mb-4" v-on:click="resetQuiz">Palaa alkuun</v-btn>

    <v-container xs12>
        <v-layout row  wrap>
        <v-flex xs6 md6>
            <v-card flat tile class="v-cardi">
                <v-img class="footer-logos" src="img/2016_metsakeskus_pysty.png" height="75px" contain />
            </v-card>
        </v-flex>
        <v-flex xs6 md6>
            <v-card flat tile class="v-cardi">
                <v-img class="footer-logos" src="img/lapinamk_cmyk.svg" height="75px" contain />
            </v-card>
        </v-flex>
        <v-flex xs6 md6>
            <v-card flat tile class="v-cardi">
                <v-img class="footer-logos" src="img/4H_RGB.png" height="75px" contain />
            </v-card>
        </v-flex>
        <v-flex xs6 md6>
            <v-card flat tile class="v-cardi">
                <v-img class="footer-logos" src="img/ELY.svg" height="75px" contain />
            </v-card>
        </v-flex>
        <v-flex xs6 md6>
            <v-card flat tile class="v-cardi">
                <v-img class="footer-logos" src="img/maaseutu.svg" height="75px"  contain />
            </v-card>
        </v-flex>
        </v-layout>
    </v-container>
  </v-flex>
    </v-layout>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Results',
  computed: {
    ...mapState('metsanomistaja', ['profiles', 'currentAnswers'])
  },
  data: function() {
      return {
          profile: {},
          description: "",
          image: "",
      }
  },
  methods: {
      getProfile() {
          let points = this.currentAnswers.reduce((acc, curr) => { return acc + curr.answer.points }, 0)
          this.profile = this.profiles.find(p => {
              return points >= p.minpoints && points <= p.maxpoints;
          });
      },

      resetQuiz() {
          this.$store.dispatch('metsanomistaja/resetQuiz', { router: this.$router });
      },

      shareOnFacebook() {
          // eslint-disable-next-line
          FB.ui({
            method: 'share_open_graph',
            action_type: 'og.likes',
            action_properties: JSON.stringify({
                object: {
                    'og:url': 'http://metsatuotto.plab.fi',
                    'og:title': 'Metsätuotto profiilini on ' + this.profile.profile,
                    'og:description': 'Löydä oma profiilisi metsätuotto testillä!',
                    'og:image': "http://metsatuotto.plab.fi/img/" + this.profile.image
                }
            })
            }, function(){});
      }
  },
  mounted: function() {
      this.getProfile();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.application .theme--light.v-card, .theme--light .v-card {
    background:#f8fafa;
}

.profile-image {
    width: 200px;
}

#app > div > main > div > div > div > div > div > div > div {
    margin-bottom: 35px;
}
</style>
